<template>
  <intro-template
    @start="next"
    button-label="Commencer"
    duration="3">
    <template v-slot:module-title>
      Déclarer du temps de travail supplémentaire
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre...
    </template>
    <template v-slot:learnings>
      <p>Les étapes de la procédure de déclaration du temps de travail supplémentaire sur la GTA</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Simulez
        </p>
        <p class="value">
          la déclaration du temps de travail supplémentaire
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
